import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-light text-dark border-top py-4 mt-5">
            <Container>
                <Row>
                    <Col md={4} className="text-center text-md-start mb-3 mb-md-0">
                        <a href="https://greateight.ch/impressum/" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark">
                            Impressum/Datenschutzerklärung
                        </a>
                        <span className="mx-2">|</span>
                        <a href="https://greateight.ch/ticketshop-agb/" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark">
                            AGB
                        </a>
                    </Col>

                    <Col md={4} className="text-center mb-3 mb-md-0">
                        <a href="mailto:info@greateight.ch" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark">
                            info@greateight.ch
                        </a>
                    </Col>

                    <Col md={4} className="text-center text-md-end">
                        © {currentYear} Great Eight - <a href="https://fetz-gr.ch" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark">
                            Noah Fetz
                        </a>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
